import Vue from 'vue'
import Router from 'vue-router'
import bus from '@/common/bus'

Vue.use(Router)

function _(name: string) {
  return () => import(`@/views/${name}.vue`)
}

const routes: any = [
  {
    path: '/',
    name: 'dashboard-index',
    class: 'iconfont iconshouye',
    hidden: false,
    component: _('monthlyReport/Detail'),
    meta: { requiresAuth: true, checkPass: true }
  },
  {
    path: '/login',
    name: 'login',
    class: 'iconfont iconshouye',
    hidden: false,
    component: _('Login')
  },
  {
    path: '/changePassword',
    name: 'change-password',
    class: 'iconfont iconshouye',
    hidden: false,
    component: _('ChangePassword'),
    meta: { requiresAuth: true, checkPass: false }
  }
]

const router = new Router({
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    return router.replace({
      path: '/404'
    })
  }

  if (to.matched.some((record: any) => record.meta.requiresAuth)) {
    if (localStorage.getItem('enterpriseToken') === null) {
      bus.$emit('exception:401')
    } else {
      if (to.matched.some((record: any) => record.meta.checkPass)) {
        let enterprise: any = JSON.parse(localStorage.getItem('enterprise') || '')
        if (enterprise.need_change_password === true) {
          if (from.path !== '/changePassword') {
            return router.replace({
              path: '/changePassword'
            })
          }
        } else {
          next()
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
